var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},style:(_vm.pieStyle),attrs:{"id":_vm.ChartID}})
}
var staticRenderFns = []

export { render, staticRenderFns }